import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator"; //@ts-check

import Utils from '../../../../utils';
var XML_FORM_DECLARATION = '<?xml version="1.0" encoding="utf-8"?>';
var DATA_CACHING = {};
/**
 * @param {import('./types').EcrionFormState} formState
 * @param {any} trackingData
 * @return {Promise<string>}
 */

var getFormXml =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(formState, trackingData) {
    var formField;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            formField = formState.fields[formState.formId];

            if (!(formField.type !== 'form')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return resolveAsyncProcessing(formState);

          case 5:
            return _context.abrupt("return", XML_FORM_DECLARATION + serializeContainer(formState, formField, trackingData));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getFormXml(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @param {import('./types').EcrionFormState} formState
 * @param {import('./types').EcrionFormContainer} container
 * @param {any} trackingData
 */


var serializeContainer = function serializeContainer(formState, container, trackingData) {
  if (!container) return '';
  var attributes = serializeAttributes(container, formState, trackingData);
  var result = "<".concat(container.name).concat(attributes, ">");
  if (isDataContainer(container)) result += '<item>';
  container.children && container.children.forEach(function (child) {
    var field = formState.fields[child];
    if (isFieldContainer(field)) result += serializeContainer(formState, field, trackingData);else if (isRepeatingContainer(field)) result += getRepeatingData(formState, field);else result += getFieldData(formState, field);
  });
  if (isDataContainer(container)) result += '</item>';
  result += "</".concat(container.name, ">");
  return result;
};
/**
 * @param {import('./types').EcrionFormState} formState
 * @param {import('./types').EcrionFormRepeatingField} field
 */


var getRepeatingData = function getRepeatingData(formState, field) {
  if (!field || !field.children || !field.children.length) return '';
  var result = "<".concat(field.name) + serializeAttributes(field, formState) + '>';
  var values = formState.data[field.id];
  if (!values) return '';
  field.childrenMap.forEach(function (item) {
    result += '<item>';
    item.children.map(function (fieldId) {
      result += getFieldData(formState, formState.fields[fieldId]);
    });
    result += '</item>';
  });
  return result += "</".concat(field.name, ">");
};
/**
 *
 * @param {import('./types').EcrionFormState} formState
 * @param {import('./types').EcrionFormField} field
 */


var getFieldData = function getFieldData(formState, field) {
  if (!field || !field.name || !field.id) return '';
  var result = "<".concat(field.name) + serializeAttributes(field, formState) + '>';
  var value;

  switch (field.type) {
    case 'login':
      value = getLoginValue(formState.data[field.id]);
      break;

    case 'signature':
      value = getSignatureValue(formState.data[field.id]);
      break;

    case 'file':
      value = getFileFieldData(formState.data[field.id]);
      break;

    case 'xmlfield':
      value = getXmlFieldValue(field.src);
      break;

    case 'repeating':
      return getRepeatingData(formState, field);

    default:
      value = formState.data[field.id];
      break;
  }

  if (Array.isArray(value)) {
    value.forEach(function (val) {
      return result += "<item>".concat(escapeXmlFieldValue(field.type, val), "</item>");
    });
  } else if (value) {
    if (isItemContainer(field)) result += "<item>".concat(escapeXmlFieldValue(field.type, value), "</item>");else result += escapeXmlFieldValue(field.type, value);
  }

  result += "</".concat(field.name, ">");
  return result;
};
/**
 * @param {import('./types').EcrionFormField} field
 * @param {import('./types').EcrionFormState} state
 * @param {any} trackingData
 * @returns {string}
 */


var serializeAttributes = function serializeAttributes(field, state) {
  var trackingData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var attributes = '';

  if (field.type === 'form') {
    var contactAction = field.contactAction,
        contactType = field.contactType;
    var submitLocation = window.location.toString();
    attributes += ' xmlns:eos="http://www.ecrion.com/eos4"';
    if (contactAction) attributes += " eos:contactAction=\"".concat(contactAction, "\"");
    if (contactType) attributes += " eos:contactType=\"".concat(contactType, "\"");
    if (submitLocation) attributes += " eos:url=\"".concat(escapeXml(submitLocation), "\"");

    if (trackingData) {
      var anonymousId = trackingData.anonymousUserId;
      var trackerId = trackingData.anonymousTrackerId;
      if (anonymousId) attributes += " anonymousUserId=\"".concat(anonymousId, "\"");
      if (trackerId) attributes += " anonymousTrackerId=\"".concat(trackerId, "\"");
    }

    return attributes;
  }

  if (field.type === 'file') {
    var data = state.data[field.id];
    if (data && data.fileName) attributes += " fileName=\"".concat(escapeXml(data.fileName), "\"");
  } // special attribute for contact fields


  if (field.isContactField) attributes += ' eos:type="eos-contact-field"';
  return attributes;
};
/**
 *
 * @param {import('./types').EcrionFormField} field
 * @returns {boolean} True if current field is a container field
 */


var isFieldContainer = function isFieldContainer(field) {
  if (field.type === 'form' || field.type === 'subform' || field.type === 'page' || field.type === 'datagroup') return true;
  return false;
};

var isRepeatingContainer = function isRepeatingContainer(field) {
  return field.type === 'repeating';
};

var isDataContainer = function isDataContainer(field) {
  if (field.type === 'datagroup') return true;
  return false;
};

var isItemContainer = function isItemContainer(field) {
  if (field.type === 'dropdown' || field.type === 'radiogroup') return true;
  return false;
};

var getFileFieldData = function getFileFieldData(data) {
  if (!data) return data || '';
  if (typeof data === 'string') return data || '';
  return data.value || '';
};

var getLoginValue = function getLoginValue(value) {
  var loginData = {
    Url: value.Url,
    Username: value.Username,
    Token: value.Token,
    Environment: value.Environment
  };
  var result = '';

  for (var key in loginData) {
    result += "<".concat(key, ">").concat(loginData[key], "</").concat(key, ">");
  }

  return result;
};
/**
 * @param {string} value
 */


var getSignatureValue = function getSignatureValue(value) {
  if (!value) return value;
  if (!DATA_CACHING[value]) return '';
  return DATA_CACHING[value];
};

var encryptSignature =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(signatureData) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (signatureData) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", Promise.resolve(signatureData));

          case 2:
            if (!DATA_CACHING[signatureData]) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", Promise.resolve(DATA_CACHING[signatureData]));

          case 4:
            return _context2.abrupt("return", Utils.request({
              method: 'POST',
              url: '/backend/cryptography?type=signature',
              contentType: 'json',
              data: JSON.stringify(signatureData)
            }).then(function (encrypted) {
              return DATA_CACHING[signatureData] = encrypted;
            }));

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function encryptSignature(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var getXmlFieldValue = function getXmlFieldValue(src) {
  return DATA_CACHING[src] || '';
};

var fetchXmlData =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(field, formState) {
    var workspace, src;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            workspace = formState.options.workspace;
            src = field.src;

            if (src) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", Promise.resolve(''));

          case 4:
            if (!formState.data[field.id]) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", Promise.resolve(formState.data[field.id]).then(function (content) {
              return DATA_CACHING[src] = content;
            }));

          case 6:
            if (!DATA_CACHING[src]) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return", Promise.resolve(DATA_CACHING[src]));

          case 8:
            return _context3.abrupt("return", Utils.apiClients.content.getContent(workspace, src).then(function (content) {
              DATA_CACHING[src] = content && content.replace(/\<\?xml.+\?\>|\<\!DOCTYPE.+]\>/g, '');
            }));

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchXmlData(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();

var resolveAsyncProcessing =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(formState) {
    var signaturePromisses, xmlPromisses;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            signaturePromisses = Object.keys(formState.fields).filter(function (fieldId) {
              return formState.fields[fieldId].type === 'signature';
            }).map(function (fieldId) {
              return encryptSignature(formState.data[fieldId]);
            });
            xmlPromisses = Object.keys(formState.fields).filter(function (fieldId) {
              return formState.fields[fieldId].type === 'xmlfield';
            }).map(function (fieldId) {
              return fetchXmlData(formState.fields[fieldId], formState);
            });
            return _context4.abrupt("return", Promise.all(signaturePromisses.concat(xmlPromisses)));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function resolveAsyncProcessing(_x6) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @param {import('./types').EcrionFormFieldType} type
 * @param {any} value
 */


var escapeXmlFieldValue = function escapeXmlFieldValue(type, value) {
  if (!value) return value;
  /**@type {Array<import('./types').EcrionFormFieldType>}*/

  var types = ['textbox', 'textarea', 'googleaddress', 'file', 'dropdown'];
  if (types.includes(type)) return escapeXml(value);
  return value;
};

var escapeXml = function escapeXml(unsafe) {
  if (typeof unsafe !== 'string') return unsafe;
  return unsafe.replace(/[<>&'"\r\n]/g, function (c) {
    switch (c) {
      case '<':
        return '&lt;';

      case '>':
        return '&gt;';

      case '&':
        return '&amp;';

      case "'":
        return '&apos;';

      case '"':
        return '&quot;';

      case '\r':
        return '&#13;';

      case '\n':
        return '&#10;';
    }
  });
};

export default {
  getFormXml: getFormXml
};